import NiceModal from "@ebay/nice-modal-react";
import ActivityOfflineNoticeModal, { ActivityOfflineNoticeModalProps } from "./modal";

export const showActivityOfflineNoticeModal = (props: ActivityOfflineNoticeModalProps) => {
  return NiceModal.show(ActivityOfflineNoticeModal, props);
};

export const hideActivityOfflineNoticeModal = () => {
  return NiceModal.hide(ActivityOfflineNoticeModal);
};

export default ActivityOfflineNoticeModal;

